import * as React from "react";
import { connect } from "react-redux";
import { Form, actions } from "react-redux-form";
import { routerActions } from "react-router-redux";
import Alert from "react-s-alert";
import ReactTable, { RowInfo } from "react-table";
import { bindActionCreators } from "redux";
import * as NavigationActions from "../../../actions/navigation";
import * as ToggleActions from "../../../actions/pages/togglePage";
import * as TrialActions from "../../../actions/trial";
import * as TrialInstitutionItemCustomViewActions from "../../../actions/trialInstitutionItemCustomView";
import { NotificationAlert } from "../../../components/common/index";
import {
    CheckboxFormInput,
    NumberFormInput,
    TextAreaFormInput,
    TextFormInput,
} from "../../../components/form/index";
import { TruncatedCell } from "../../../components/layouts/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import { PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import {
    renderRegistrationFormSaveBlock,
    renderRegistrationFormSaveSuccess,
    renderRegistrationFormSaveWarning,
} from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import * as FormHelper from "../../../helpers/formHelper";
import {
    RegistrationComponent,
    renderFormControls,
} from "../../../helpers/formHelper";
import * as ToggleHelper from "../../../helpers/toggleHelper";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { TogglePageItem } from "../../../reducers/pages/togglePage";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import {
    ITrialInstitutionItemCustomViewReduxFormState,
    initialTrialInstitutionItemCustomViewState,
} from "../../../reducers/reactReduxForms/trialInstitutionItemCustomView";
import { TrialLayout } from "../../index";
import "./TrialInstitutionItemCustomViewPage.scss";

import { ComponentType } from "react";
import { TrialInstitutionItemCustomViewBreadcrumbs } from "../../../helpers/breadcrumbHelper";
import { TrialSubMenu } from "../../../helpers/subMenuHelper";
import RouterHoc, {
    IRouterActions,
    IRouterProps,
} from "../../../hoc/RouterHoc";

interface ITrialInstitutionItemCustomViewPageParams {
    trialId: number;
    trialInstitutionItemCustomViewId: number;
}

interface ITrialInstitutionItemCustomViewPageProps
    extends IRouterProps<ITrialInstitutionItemCustomViewPageParams> {
    form: Dtos.TrialInstitutionItemCustomView & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: ITrialInstitutionItemCustomViewReduxFormState;

    trialId: number;
    trialInstitutionItemCustomViewId: number;

    // From state
    trialInstitutionItemCustomView: Dtos.TrialInstitutionItemCustomView;
    trialItemSelections: Dtos.TrialItemSelection[];
    trial: Dtos.Trial;
    lookups: Dtos.Lookup[];

    loadingTrial: boolean;
    loadTrialSuccess: boolean;
    loadTrialFailure: boolean;
    loadTrialErrorCode: string;

    loadingTrialInstitutionItemCustomView: boolean;
    loadTrialInstitutionItemCustomViewSuccess: boolean;
    loadTrialInstitutionItemCustomViewFailure: boolean;
    loadTrialInstitutionItemCustomViewErrorCode: string;

    savingTrialInstitutionItemCustomView: boolean;
    saveTrialInstitutionItemCustomViewSuccess: boolean;
    saveTrialInstitutionItemCustomViewFailure: boolean;

    creatingTrialInstitutionItemCustomView: boolean;
    createTrialInstitutionItemCustomViewSuccess: boolean;
    createTrialInstitutionItemCustomViewFailure: boolean;

    validationFailures: Dtos.ResponseError[];

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    toggleItems: TogglePageItem[];
}

interface ITrialInstitutionItemCustomViewPageActions extends IRouterActions {
    clearTrialInstitutionItemCustomView: TrialInstitutionItemCustomViewActions.ITrialInstitutionItemCustomViewClearActionCreator;
    loadTrialInstitutionItemCustomView: TrialInstitutionItemCustomViewActions.ITrialInstitutionItemCustomViewLoadByIdActionCreator;
    saveTrialInstitutionItemCustomView: TrialInstitutionItemCustomViewActions.ITrialInstitutionItemCustomViewSaveActionCreator;
    createTrialInstitutionItemCustomView: TrialInstitutionItemCustomViewActions.ITrialInstitutionItemCustomViewCreateActionCreator;

    clearTrial: TrialActions.ITrialClearActionCreator;
    loadTrial: TrialActions.ITrialLoadByIdActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    toggleExpand: ToggleActions.IToggleExpandedStateActionCreator;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;
}

type TrialInstitutionItemCustomViewPageProps =
    ITrialInstitutionItemCustomViewPageProps &
        ITrialInstitutionItemCustomViewPageActions;

const reduxFormName: string = "reduxForms.trialInstitutionItemCustomView";
const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex";
const tableStyleClass: React.CSSProperties = {
    textAlign: "left",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer",
};

class TrialInstitutionItemCustomViewPage extends React.PureComponent<
    TrialInstitutionItemCustomViewPageProps,
    any
> {
    initialised: boolean;
    constructor(props: TrialInstitutionItemCustomViewPageProps) {
        super(props);

        this.state = {
            showAll: true,
        };

        this.clearTrialInstitutionItemCustomView =
            this.clearTrialInstitutionItemCustomView.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
    }

    componentDidMount() {
        const {
            loadTrialInstitutionItemCustomView,
            createTrialInstitutionItemCustomView,
            trialInstitutionItemCustomViewId,
            trialId,
            loadTrial,
            setDrawerItems,
            permissions,
            setBreadcrumbs
        } = this.props;
        

        setDrawerItems(TrialSubMenu(trialId, permissions));
        setBreadcrumbs(TrialInstitutionItemCustomViewBreadcrumbs(trialId));

        if (trialInstitutionItemCustomViewId) {
            loadTrialInstitutionItemCustomView(
                trialInstitutionItemCustomViewId
            );
            this.setState({ showAll: false });
        } else if (!trialInstitutionItemCustomViewId) {
            createTrialInstitutionItemCustomView(trialId, 0, 0);
            this.setState({ showAll: true });
        }
        loadTrial(trialId);
    }

    componentDidUpdate(
        prevProps: TrialInstitutionItemCustomViewPageProps,
        _prevState
    ) {
        const {
            form,
            trialId,
            trialInstitutionItemCustomViewId,
            trialInstitutionItemCustomView,
            loadTrialInstitutionItemCustomView,
            loadTrial,
            loadingTrialInstitutionItemCustomView,
            loadTrialInstitutionItemCustomViewSuccess,
            savingTrialInstitutionItemCustomView,
            saveTrialInstitutionItemCustomViewSuccess,
            createTrialInstitutionItemCustomView,
            validationFailures,
            creatingTrialInstitutionItemCustomView,
            createTrialInstitutionItemCustomViewSuccess,
            navigate,
            trial,
            setBreadcrumbs,
            permissions,
            setDrawerItems,
            loadTrialFailure,
            loadTrialInstitutionItemCustomViewFailure,
            loadTrialInstitutionItemCustomViewErrorCode,
            loadTrialErrorCode,
        } = this.props;

        if (loadTrialFailure) {
            navigate(`/error/${loadTrialErrorCode}`);
        }
        if (loadTrialInstitutionItemCustomViewFailure) {
            navigate(`/error/${loadTrialInstitutionItemCustomViewErrorCode}`);
        }

        if (trial?.displayName && !this.initialised) {
            setDrawerItems(TrialSubMenu(trialId, permissions));
            setBreadcrumbs(TrialInstitutionItemCustomViewBreadcrumbs(trialId));
            this.initialised = true;
        }

        if (trialId && prevProps.trialId != trialId) {
            loadTrial(trialId);
        }

        if (
            trialInstitutionItemCustomViewId &&
            prevProps.trialInstitutionItemCustomViewId !=
                trialInstitutionItemCustomViewId
        ) {
            loadTrialInstitutionItemCustomView(
                trialInstitutionItemCustomViewId
            );
        } else if (
            !trialInstitutionItemCustomViewId &&
            prevProps.trialInstitutionItemCustomViewId
        ) {
            createTrialInstitutionItemCustomView(trialId, 0, 0);
        }

        if (
            !loadingTrialInstitutionItemCustomView &&
            prevProps.loadingTrialInstitutionItemCustomView
        ) {
            if (loadTrialInstitutionItemCustomViewSuccess) {
                this.loadForm();
            }
        }

        if (
            !savingTrialInstitutionItemCustomView &&
            prevProps.savingTrialInstitutionItemCustomView
        ) {
            if (saveTrialInstitutionItemCustomViewSuccess) {
                if (validationFailures && validationFailures.length > 0) {
                    Alert.warning(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveWarning(
                                validationFailures
                            )}
                            icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                        />
                    );

                    // toggleMessageModal();
                } else {
                    Alert.success(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveSuccess()}
                            icon={FontAwesomeIcons.Solid.CHECK}
                        />
                    );
                }
                if (form.saveAndReturn) {
                    navigate(
                        "/trials/" + trialId + "/trialinstitutionitemviews"
                    );
                } else if (
                    !form.saveAndReturn &&
                    trialInstitutionItemCustomViewId &&
                    trialInstitutionItemCustomViewId > 0
                ) {
                    this.loadForm();
                } else if (
                    !form.saveAndReturn &&
                    !trialInstitutionItemCustomViewId &&
                    trialInstitutionItemCustomView &&
                    trialInstitutionItemCustomView.id > 0
                ) {
                    navigate(
                        "/trials/" +
                            trialId +
                            "/trialinstitutionitemviews/" +
                            trialInstitutionItemCustomView.id
                    );
                    this.loadForm();
                }
            } else {
                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );
            }
        }

        if (
            !creatingTrialInstitutionItemCustomView &&
            prevProps.creatingTrialInstitutionItemCustomView
        ) {
            if (createTrialInstitutionItemCustomViewSuccess) {
                this.loadForm();
            }
        }
    }

    componentWillUnmount() {
        const { resetForm, loadForm } = this.props;

        this.clearTrialInstitutionItemCustomView();
        loadForm(reduxFormName, initialTrialInstitutionItemCustomViewState);
        resetForm(reduxFormName);
    }

    clearTrialInstitutionItemCustomView() {
        this.props.clearTrialInstitutionItemCustomView();
        this.props.clearTrial();
    }

    showTrialInstitutionItemCustomView(): boolean {
        const {
            loadingTrial,
            loadingTrialInstitutionItemCustomView,
            loadTrialInstitutionItemCustomViewSuccess,
        } = this.props;

        if (
            !loadingTrial &&
            !loadingTrialInstitutionItemCustomView &&
            loadTrialInstitutionItemCustomViewSuccess
        ) {
            return true;
        }

        return false;
    }

    render() {
        const { loadingTrial, loadingTrialInstitutionItemCustomView } =
            this.props;

        return (
            <TrialLayout
                loading={loadingTrial || loadingTrialInstitutionItemCustomView}
                permission={Dtos.Permission.TrialItemUpdate}
            >
                {this.renderContent()}
            </TrialLayout>
        );
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            savingTrialInstitutionItemCustomView,
            permissions,
        } = this.props;

        let self = this;
        const hasPermission: boolean =
            AuthenticationHelper.hasCreateEditPermission(
                form,
                permissions,
                Dtos.Permission.TrialItemUpdate,
                Dtos.Permission.TrialItemCreate
            );
        const _formNew: boolean = FormHelper.isNew(formState, form);

        const formDisabled: boolean =
            !hasPermission ||
            savingTrialInstitutionItemCustomView ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            name: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
            },
            description: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextAreaFormInput,
                inputDisabled: formDisabled,
            },
            sortOrder: {
                type: RegistrationComponent.RegistrationControl,
                inputType: NumberFormInput,
                inputDisabled: formDisabled,
            },
            isShared: {
                type: RegistrationComponent.RegistrationControl,
                inputType: CheckboxFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    label: "Shared",
                },
                inputLabel: " ",
            },
            compactTextArea: {
                type: RegistrationComponent.RegistrationControl,
                inputType: CheckboxFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    label: "Single line text entry (Default)",
                },
                inputLabel: " ",
            },
            active: {
                type: RegistrationComponent.RegistrationControl,
                inputType: CheckboxFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    label: "Active",
                },
                inputLabel: " ",
            },
        };

        return (
            <div>
                <div className="row">
                    <div className={"col mb-2"}>
                        <h1>Institution Item Custom View</h1>
                    </div>
                    <div className="col-auto"></div>
                </div>
                <Form
                    model={reduxFormName}
                    onSubmit={(val, _event) => this.handleOnSubmit(val)}
                    onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
                >
                    <div className="container-fluid">
                        {renderFormControls(
                            form,
                            "trialInstitutionItemCustomView",
                            formComponents,
                            lookups,
                            validationFailures,
                            formProperties,
                            changeForm
                        )}
                    </div>
                    <div className="row">
                        <div className={"col mb-2 mt-2"}>
                            <h3>Trial Items</h3>
                        </div>
                        <div className="col-auto mt-2">
                            <button
                                onClick={() => {
                                    self.setState({
                                        showAll: !self.state.showAll,
                                    });
                                }}
                                type="button"
                                className="btn btn-secondary btn-small mr-2"
                            >
                                {this.state.showAll
                                    ? "Show selected"
                                    : "Show all"}
                            </button>
                        </div>
                    </div>
                    {this.renderCategories()}

                    <div className="mt-4 mb-4 text-right">
                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                this.props.changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    false
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit
                        </button>

                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                this.props.changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    true
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit And Return
                        </button>
                        <button
                            onClick={this.onCancel}
                            className="btn btn-primary mr-2"
                        >
                            {" "}
                            Cancel{" "}
                        </button>
                    </div>
                </Form>
            </div>
        );
    }

    renderCategories() {
        const { trialId, form, toggleItems, toggleExpand } = this.props;

        if (
            !form ||
            !form.trialItemSelections ||
            form.trialItemSelections.length == 0
        ) {
            return (
                <div className="card card-shadow p-3">
                    <div className="alert alert-info d-flex mb-0">
                        <div className="mr-2">
                            <FontAwesomeIcon
                                icon={FontAwesomeIcons.Solid.INFO_SQUARE}
                                fixedWidth
                            />
                        </div>
                        <span>There are currently no items to select.</span>
                    </div>
                </div>
            );
        }

        return (
            <div>
                {form.trialItemSelections.map((item, index) => {
                    const key =
                        "trial-item-selection-category-page-" +
                        item.category.id +
                        "-" +
                        trialId;
                    const expanded = ToggleHelper.isToggleExpanded(
                        toggleItems,
                        key
                    );
                    if (!this.state.showAll) {
                        let hasSelections = false;
                        item.trialItemSelectionItems.forEach((tisi) => {
                            tisi.trialItemSelectionItemComponents.forEach(
                                (tisic) => {
                                    hasSelections =
                                        hasSelections ||
                                        tisic.trialItemSelectionPrimitives.filter(
                                            (f) => f.selected
                                        ).length > 0;
                                }
                            );
                        });

                        if (!hasSelections) {
                            return <></>;
                        }
                    }
                    return (
                        <div
                            key={
                                "trial-item-selection-category" +
                                item.category.id
                            }
                        >
                            <div
                                className={tableHeaderClass}
                                style={tableStyleClass}
                                onClick={() => toggleExpand(key)}
                            >
                                <div>
                                    <FontAwesomeIcon
                                        icon={
                                            !expanded
                                                ? FontAwesomeIcons.Solid
                                                      .ANGLE_DOWN
                                                : FontAwesomeIcons.Solid
                                                      .ANGLE_UP
                                        }
                                        fixedWidth
                                        transform="grow-16"
                                        className="mr-3"
                                    />
                                </div>
                                <span>{item.category.name}</span>
                            </div>
                            {expanded &&
                                this.renderTrialItems(
                                    item.trialItemSelectionItems,
                                    index
                                )}
                        </div>
                    );
                })}
            </div>
        );
    }

    renderTrialItems(
        trialItemSelectionItems: Dtos.TrialItemSelectionItem[],
        categoryIndex: number
    ) {
        //this.props.changeForm(reduxFormName + ".saveAndReturn", false);

        let filteredItems = [...trialItemSelectionItems];
        //for (var i = 0; i < filteredItems.length; i++) {
        //    filteredItems[i].originalIndex = i;
        //}

        if (!this.state.showAll) {
            filteredItems = filteredItems.filter((f) => {
                let show: boolean = false;
                f.trialItemSelectionItemComponents.forEach((itemComponent) => {
                    show =
                        show ||
                        itemComponent.trialItemSelectionPrimitives.filter(
                            (f) => f.selected
                        ).length > 0;
                });
                return show;
            });
        }

        return (
            <ReactTable
                data={filteredItems}
                pageSizeOptions={PAGE_SIZE_OPTIONS}
                defaultPageSize={filteredItems.length}
                pageSize={filteredItems.length}
                showPagination={false}
                className="-striped -highlight -clickable"
                noDataText="There are currently no trial items for this category"
                resizable={false}
                getTdProps={(_state, _rowInfo: RowInfo, _column, _instance) => {
                    return {
                        onClick: (_e, _handleOriginal) => {},
                    };
                }}
                columns={[
                    {
                        id: "name",
                        Header: "Name",
                        accessor: "name",
                        Cell: (props) => <TruncatedCell value={props.value} />,
                    },
                    {
                        id: "trialItemSelectionItemComponents",
                        Header: "Component Primitives",
                        accessor: "trialItemSelectionItemComponents",
                        Cell: (props) => {
                            return this.renderTrialItemComponents(
                                props.value,
                                props.original.originalIndex,
                                categoryIndex
                            );
                        },
                    },
                ]}
            />
        );
    }

    renderTrialItemComponents(
        trialItemSelectionItemComponents: Dtos.TrialItemSelectionItemComponent[],
        trialItemIndex: number,
        categoryIndex: number
    ) {
        const { changeForm } = this.props;

        if (!trialItemSelectionItemComponents) {
            return <p>Empty</p>;
        }
        let hasPreviousPrimitives = false;
        return (
            <div className="container-fluid">
                {trialItemSelectionItemComponents.map(
                    (item, trialItemSelectionItemComponentIndex) => {
                        let itemPrimitives = [
                            ...item.trialItemSelectionPrimitives,
                        ];
                        if (!this.state.showAll) {
                            itemPrimitives = itemPrimitives.filter(
                                (f) => f.selected
                            );
                        }
                        let content = (
                            <div className="row">
                                <div className="pl-0 col-11">
                                    {hasPreviousPrimitives &&
                                        itemPrimitives.length > 0 && ( //&&
                                            //trialItemSelectionItemComponentIndex < trialItemSelectionItemComponents.length - 1
                                            <hr className="m-1" />
                                        )}

                                    {itemPrimitives.map(
                                        (
                                            itemPrimitive,
                                            _itemPrimitiveIndex
                                        ) => (
                                            <>
                                                <div className="d-flex">
                                                    <div className="ml-2">
                                                        <CheckboxFormInput
                                                            name={`selecteditemprimitive_${categoryIndex}_${trialItemIndex}_${trialItemSelectionItemComponentIndex}_${itemPrimitive.id}`}
                                                            id={`selecteditemprimitive_${categoryIndex}_${trialItemIndex}_${trialItemSelectionItemComponentIndex}_${itemPrimitive.id}`}
                                                            className="mt-1 mr-1"
                                                            value={
                                                                itemPrimitive.selected
                                                            }
                                                            onChange={(
                                                                v,
                                                                _o
                                                            ) => {
                                                                if (
                                                                    item.hasConditions
                                                                ) {
                                                                    var linkedIndexes =
                                                                        item.trialItemSelectionPrimitives.map(
                                                                            (
                                                                                a,
                                                                                b
                                                                            ) =>
                                                                                b
                                                                        );
                                                                    linkedIndexes.forEach(
                                                                        (
                                                                            linkedIndex
                                                                        ) => {
                                                                            let path: string = `reduxForms.trialInstitutionItemCustomView.trialItemSelections[${categoryIndex}].trialItemSelectionItems[${trialItemIndex}].trialItemSelectionItemComponents[${trialItemSelectionItemComponentIndex}].trialItemSelectionPrimitives[${linkedIndex}].selected`;
                                                                            changeForm(
                                                                                path,
                                                                                v
                                                                            );
                                                                        }
                                                                    );
                                                                    return null;
                                                                }

                                                                let path: string = `reduxForms.trialInstitutionItemCustomView.trialItemSelections[${categoryIndex}].trialItemSelectionItems[${trialItemIndex}].trialItemSelectionItemComponents[${trialItemSelectionItemComponentIndex}].trialItemSelectionPrimitives[${itemPrimitive.originalIndex}].selected`;
                                                                changeForm(
                                                                    path,
                                                                    v
                                                                );
                                                                return null;
                                                            }}
                                                            hideLabel={true}
                                                            additionalContent={
                                                                ""
                                                            }
                                                        />
                                                    </div>
                                                    <div className="flex-grow-1 p-1">
                                                        <span>
                                                            {
                                                                itemPrimitive.label
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    )}
                                </div>
                                <div className="px-0 col-1">
                                    {itemPrimitives.length > 0 &&
                                        item.hasConditions && (
                                            <div className="mt-2">
                                                <FontAwesomeIcon
                                                    icon={
                                                        FontAwesomeIcons.Light
                                                            .PAPERCLIP
                                                    }
                                                    fixedWidth
                                                />
                                            </div>
                                        )}
                                </div>
                            </div>
                        );
                        hasPreviousPrimitives = itemPrimitives.length > 0;
                        return content;
                    }
                )}
            </div>
        );
    }

    renderErrorAlert(): any {
        return (
            <div>
                The form was <strong> not </strong> saved.
            </div>
        );
    }

    renderWarningAlert(): any {
        const { validationFailures } = this.props;

        return (
            <div>
                The form was saved but was invalid with{" "}
                {validationFailures.length} errors.
            </div>
        );
    }

    renderSaveSuccessAlert(): any {
        return <div>The form has been saved successfully</div>;
    }

    handleOnSubmit(data: Dtos.TrialInstitutionItemCustomView) {
        const { saveTrialInstitutionItemCustomView } = this.props;

        if (data) {
            let changes: Dtos.TrialInstitutionItemCustomView =
                {} as Dtos.TrialInstitutionItemCustomView;
            saveTrialInstitutionItemCustomView(
                Object.assign({ ...data }, changes)
            );
        }
    }

    handleOnSubmitFailed(_data: Dtos.Trial) {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    }

    onCancel() {
        const { trialId, navigate } = this.props;

        navigate("/trials/" + trialId + "/trialinstitutionitemviews");
    }

    loadForm() {
        const { loadForm, trialInstitutionItemCustomView } = this.props;

        let extraData: Dtos.TrialInstitutionItemCustomView =
            {} as Dtos.TrialInstitutionItemCustomView;

        loadForm(
            reduxFormName,
            Object.assign({ ...trialInstitutionItemCustomView }, extraData)
        );
    }
}

const mapStateToProps = (
    state: ITmdState,
    ownProps: TrialInstitutionItemCustomViewPageProps
): ITrialInstitutionItemCustomViewPageProps => {
    let trial: Dtos.Trial | undefined = !(
        state.trials.formData instanceof Array
    )
        ? state.trials.formData
        : undefined;
    let trialInstitutionItemCustomView:
        | Dtos.TrialInstitutionItemCustomView
        | undefined = !(
        state.trialInstitutionItemCustomView.formData instanceof Array
    )
        ? state.trialInstitutionItemCustomView.formData
        : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];
    let trialItemSelections = trialInstitutionItemCustomView
        ? trialInstitutionItemCustomView.trialItemSelections
        : [];

    return {
        match: ownProps.match,
        trialId: ownProps.match ? ownProps.match.params.trialId : undefined!,
        trialInstitutionItemCustomViewId:
            ownProps.match &&
            ownProps.match.params.trialInstitutionItemCustomViewId.toString() !=
                "create"
                ? ownProps.match.params.trialInstitutionItemCustomViewId
                : undefined!,

        history: ownProps.history,
        location: ownProps.location,

        trialInstitutionItemCustomView: trialInstitutionItemCustomView!,
        trialItemSelections: trialItemSelections,
        trial: trial!,

        loadingTrialInstitutionItemCustomView:
            state.trialInstitutionItemCustomView.loadState &&
            state.trialInstitutionItemCustomView.loadState.status ==
                RequestState.Pending,
        loadTrialInstitutionItemCustomViewSuccess:
            state.trialInstitutionItemCustomView.loadState &&
            state.trialInstitutionItemCustomView.loadState.status ==
                RequestState.Success,
        loadTrialInstitutionItemCustomViewFailure:
            state.trialInstitutionItemCustomView.loadState &&
            state.trialInstitutionItemCustomView.loadState.status ==
                RequestState.Failure,
        loadTrialInstitutionItemCustomViewErrorCode:
            state.trialInstitutionItemCustomView.loadState.errorCode,

        savingTrialInstitutionItemCustomView:
            state.trialInstitutionItemCustomView.saveState &&
            state.trialInstitutionItemCustomView.saveState.status ==
                RequestState.Pending,
        saveTrialInstitutionItemCustomViewSuccess:
            state.trialInstitutionItemCustomView.saveState &&
            state.trialInstitutionItemCustomView.saveState.status ==
                RequestState.Success,
        saveTrialInstitutionItemCustomViewFailure:
            state.trialInstitutionItemCustomView.saveState &&
            state.trialInstitutionItemCustomView.saveState.status ==
                RequestState.Failure,

        creatingTrialInstitutionItemCustomView:
            state.trialInstitutionItemCustomView.createState &&
            state.trialInstitutionItemCustomView.createState.status ==
                RequestState.Pending,
        createTrialInstitutionItemCustomViewSuccess:
            state.trialInstitutionItemCustomView.createState &&
            state.trialInstitutionItemCustomView.createState.status ==
                RequestState.Success,
        createTrialInstitutionItemCustomViewFailure:
            state.trialInstitutionItemCustomView.createState &&
            state.trialInstitutionItemCustomView.createState.status ==
                RequestState.Failure,

        loadingTrial:
            state.trials.loadState &&
            state.trials.loadState.status == RequestState.Pending,
        loadTrialSuccess:
            state.trials.loadState &&
            state.trials.loadState.status == RequestState.Success,
        loadTrialFailure:
            state.trials.loadState &&
            state.trials.loadState.status == RequestState.Failure,
        loadTrialErrorCode: state.trials.loadState.errorCode,

        user: state.user.data,
        permissions: permissions,
        lookups: state.trialInstitutionItemCustomView.lookups,

        form: state.reduxForms.trialInstitutionItemCustomView,
        formState: state.trialInstitutionItemCustomView.formState,
        formProperties: state.trialInstitutionItemCustomView.formProperties,

        reduxFormState:
            state.reduxForms.formState.trialInstitutionItemCustomView,
        validationFailures: state.trialInstitutionItemCustomView.formData
            ? state.trialInstitutionItemCustomView.validationFailures
            : undefined,

        toggleItems: state.togglePage.items,
    };
};

const mapDispatchToProps = (
    dispatch,
    ownProps: TrialInstitutionItemCustomViewPageProps
): ITrialInstitutionItemCustomViewPageActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadTrialInstitutionItemCustomView: bindActionCreators(
            TrialInstitutionItemCustomViewActions.LoadTrialInstitutionItemCustomViewById,
            dispatch
        ),
        clearTrialInstitutionItemCustomView: bindActionCreators(
            TrialInstitutionItemCustomViewActions.Clear,
            dispatch
        ),
        createTrialInstitutionItemCustomView: bindActionCreators(
            TrialInstitutionItemCustomViewActions.CreateTrialInstitutionItemCustomView,
            dispatch
        ),
        saveTrialInstitutionItemCustomView: bindActionCreators(
            TrialInstitutionItemCustomViewActions.SaveTrialInstitutionItemCustomView,
            dispatch
        ),

        loadTrial: bindActionCreators(TrialActions.LoadTrialById, dispatch),
        clearTrial: bindActionCreators(TrialActions.Clear, dispatch),

        toggleExpand: bindActionCreators(
            ToggleActions.ToggleExpanded,
            dispatch
        ),

        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        )
    };
};

export default RouterHoc<
    ITrialInstitutionItemCustomViewPageParams,
    TrialInstitutionItemCustomViewPageProps
>(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(
        TrialInstitutionItemCustomViewPage
    ) as unknown as ComponentType<TrialInstitutionItemCustomViewPageProps>
) as ComponentType<any>;
